import { useEffect, useRef, type ReactNode } from 'react';

interface Props {
  id: string;
  title: string;
  sub: ReactNode;
  onEnterView(id: string): void;
  children: ReactNode;
}

export function AdminSection({ id, title, sub, onEnterView, children }: Props) {
  const ref = useRef<HTMLElement | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) onEnterView(id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [id, onEnterView]);
  return (
    <section className="adm-section" id={id} ref={ref}>
      <h2>{title}</h2>
      <p className="adm-section__sub">{sub}</p>
      {children}
    </section>
  );
}
